<h2 mat-dialog-title>Installer Accreditation Details</h2>

<bp-loading-overlay [isLoading]="isLoading"></bp-loading-overlay>

<form [formGroup]="installerForm" (ngSubmit)="onSubmit()" novalidate>
    <mat-dialog-content>
        <p>Please provide the accreditation number for each installer who completed work on this system.</p>

        <div formArrayName="installers" class="installers-list">
            <ng-container *ngFor="let installerCtrl of installersFormArray.controls; let i = index" [formGroupName]="i">
                <div class="installer-block">
                    <h3>Installer {{ i + 1 }}</h3>

                    <!-- Accreditation Number Input -->
                    <mat-form-field appearance="outline" class="full-width">
                        <mat-label>Accreditation Number</mat-label>
                        <input
                            matInput
                            #accreditationInput
                            formControlName="accreditationNumber"
                            placeholder="Enter accreditation number"
                            required
                        />
                        <!-- Inline spinner during lookup -->
                        <mat-progress-spinner
                            *ngIf="installerCtrl.get('isLoading')?.value"
                            matSuffix
                            diameter="20"
                            mode="indeterminate"
                            color="primary"
                        ></mat-progress-spinner>
                        <mat-error *ngIf="installerCtrl.get('accreditationNumber').hasError('required')">
                            Accreditation number is required.
                        </mat-error>
                        <mat-error *ngIf="installerCtrl.get('accreditationNumber').hasError('notFound')">
                            Invalid or unknown accreditation number.
                        </mat-error>
                    </mat-form-field>

                    <!-- Installer Name (Read-only, populated by API lookup) -->
                    <div *ngIf="installerCtrl.get('name').value" class="installer-name-display">
                        <mat-icon>account_circle</mat-icon>
                        <span>{{ installerCtrl.get('name').value }}</span>
                    </div>

                    <!-- Button to remove the second installer -->
                    <div *ngIf="i > 0" class="remove-installer-container">
                        <button
                            type="button"
                            mat-button
                            color="primary"
                            class="small-remove-button"
                            (click)="removeInstaller(i)"
                        >
                            <mat-icon>remove_circle_outline</mat-icon> Remove Installer {{ i + 1 }}
                        </button>
                    </div>
                </div>
            </ng-container>
        </div>

        <!-- Button to add another installer -->
        <div class="add-installer-container">
            <button
                type="button"
                mat-stroked-button
                color="primary"
                (click)="addInstaller()"
                [disabled]="installersFormArray.length >= maxInstallers"
            >
                <mat-icon>add_circle_outline</mat-icon> Add Another Installer
            </button>
        </div>

        <!-- Confirmation Checkbox -->
        <mat-checkbox formControlName="confirmInformation" class="confirm-checkbox" required>
            I confirm that the information provided about the installers is correct and understand that providing
            incorrect accreditation details will lead to a delay in payment while we check your accreditation
            information.
        </mat-checkbox>
        <mat-error
            *ngIf="
                installerForm.get('confirmInformation').hasError('required') &&
                installerForm.get('confirmInformation').touched
            "
        >
            You must confirm the information is correct.
        </mat-error>
    </mat-dialog-content>

    <mat-dialog-actions align="end">
        <button type="button" mat-button (click)="onCancel()">Cancel</button>
        <button
            type="submit"
            mat-raised-button
            color="primary"
            [disabled]="installerForm.invalid || isLoading"
            [matTooltip]="installerForm.invalid ? 'Please fill out all required fields and confirmation' : ''"
        >
            {{ isLoading ? 'Submitting...' : 'Submit' }}
        </button>
    </mat-dialog-actions>
</form>
